/**
 * Карточка каталога: зелёная кнопка «взять весь остаток» — отдельная форма рядом
 * со штатной «в корзину» (snippets/card-product.liquid). Штатная форма после
 * своего добавления сама переходит в состояние «в корзине» (поле количества,
 * «перейти в корзину»), а про чужую форму она не знает. Здесь после успешного
 * добавления карточка приводится к тому же состоянию, что нарисовала бы тема при
 * перезагрузке: зелёная кнопка прячется, у основной формы поле = количество в
 * корзине, «в корзину» скрыта, «перейти в корзину» показана.
 *
 * Сигнал — штатный pubsub cartUpdate темы; на случай, если он не пришёл,
 * через 2,5 с корзина перечитывается напрямую.
 */
if (!window.__bfCardWholePiece) {
  window.__bfCardWholePiece = true;
  (function () {
    const pending = new Set();
    const SELECTOR = 'form.product-card__whole-piece-form';

    function flip(form, quantity) {
      const card = form.closest('.product-card');
      form.closest('.product-card__whole-piece')?.classList.add('hidden');
      if (!card) return;
      // Класс на корне держит резерв под вторую строку полосы — кнопки больше нет.
      card.classList.remove('product-card--whole-piece', 'product-card--whole-piece-note');
      const main = card.querySelector('form.product-card__main-actions');
      if (!main) return;
      const qi = main.querySelector('quantity-input');
      const input = qi?.querySelector('input');
      if (input) {
        input.value = quantity;
        input.setAttribute('data-cart-quantity', quantity);
      }
      qi?.classList.remove('hidden');
      // Пересчитать доступность «+»/«−» под новое значение (как делает тема на change).
      if (qi && typeof qi.validateQtyRules === 'function') qi.validateQtyRules();
      main.querySelector('[type="submit"]')?.classList.add('hidden');
      main.querySelector('.go-cart')?.classList.remove('hidden');
    }

    function onCart(cart) {
      for (const form of [...pending]) {
        const id = Number(form.querySelector('[name="id"]')?.value);
        // Сумма по всем строкам варианта — как `item_count_for_variant` в Liquid
        // (вишлист может дать вторую строку той же ткани).
        const quantity = (cart.items || []).filter((item) => item.variant_id === id).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        if (quantity > 0) {
          pending.delete(form);
          flip(form, quantity);
        }
      }
    }

    async function readCart() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js?_=${Date.now()}`, {
          headers: { Accept: 'application/json' },
        });
        if (response.ok) onCart(await response.json());
      } catch (error) {
        /* сеть: состояние поправится при перезагрузке */
      }
    }

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches(SELECTOR)) return;
        pending.add(form);
        setTimeout(() => {
          if (pending.has(form)) readCart();
        }, 2500);
      },
      true
    );

    function subscribe() {
      const ps = window.FoxTheme?.pubsub;
      if (!ps?.subscribe || !ps.PUB_SUB_EVENTS?.cartUpdate) return false;
      ps.subscribe(ps.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => {
        if (cart && cart.items) onCart(cart);
      });
      return true;
    }
    if (!subscribe()) {
      document.addEventListener('DOMContentLoaded', subscribe);
    }
  })();
}
